import { useState } from 'react';
import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { Page } from '@frontend/page';
import { PurchaseDevicesAction, PurchaseDeviceType } from '@frontend/purchase-devices';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';
import { RecentCallsTable } from '../components/recent-calls/recent-calls';

export const RecentCalls = () => {
  const { t } = useTranslation('calls');
  const [selectedTimeRange, setSelectedTimeRange] = useState<string>('');
  return (
    <Page css={styles}>
      <Page.Header>
        <Page.Header.Title
          title={t('Call History')}
          css={{
            // This overrides the default flex direction for the title area
            [`@container (max-width:  ${breakpoints.xsmall.max}px)`]: {
              flexDirection: 'row',
              alignItems: 'center',
              gap: theme.spacing(1),
            },
          }}
        >
          <PurchaseDevicesAction
            source='recent-calls-page'
            devices={[PurchaseDeviceType.DESK_PHONE]}
            alwaysShowMenu
            menuPlacement='bottom-start'
          />
        </Page.Header.Title>
        <Page.Header.Subtitle
          subtitle={!!selectedTimeRange && t(`Showing results for {{timerange}}.`, { timerange: selectedTimeRange })}
        />
      </Page.Header>
      <Page.Body>
        <RecentCallsTable setTimeRange={setSelectedTimeRange} />
      </Page.Body>
    </Page>
  );
};

const styles = css`
  max-width: 100%;
  overflow: auto;
  height: 100%;

  @container (max-width: ${breakpoints.xsmall.max}px) {
    padding: 0;

    .page-header {
      padding: ${theme.spacing(2, 2, 0, 2)};
      margin: 0;
    }
  }
`;
